var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row notifications-list" }, [
            _vm.notifications && _vm.notifications.length > 0
              ? _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-list-group",
                      _vm._l(_vm.notifications, function(n, k) {
                        return _c(
                          "b-list-group-item",
                          {
                            key: n.NotificationId,
                            staticClass: "flex-column align-items-start",
                            class: { new: !n.wasReaded }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex w-100 justify-content-between"
                              },
                              [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v(_vm._s(n.title))
                                ]),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(_vm._s(_vm.getTimeAgo(n.createdAt)))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-2 mb-2" }, [
                              _c("img", { attrs: { src: n.image } })
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mb-1" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(n.content) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-2" }, [
                              _c(
                                "a",
                                { attrs: { target: "_blank", href: n.link } },
                                [_vm._v("Acessar URL")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger float-right",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteNotification(
                                      n.NotificationId
                                    )
                                  }
                                }
                              },
                              [_vm._v("Apagar")]
                            ),
                            _vm._v(" "),
                            !n.wasReaded
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success float-right",
                                    attrs: { id: "markAsRead" },
                                    on: {
                                      click: function($event) {
                                        return _vm.markAsRead(
                                          n.NotificationId,
                                          k
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Lido")]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              : _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", [_vm._v("Não há notificações disponíveis.")])
                ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h2", [_vm._v("Notificações")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43a3e4e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a3e4e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = null
// module chunks = 